import AuthenticatedController from './AuthenticatedController';
import * as APIRoutes from '@mm/api-routes';
import {
  CaptureActionEnum,
  SuppressionSettingsCSVModel,
  SuppressionSettingsCSVResponse,
  SuppressionSettingsModel,
} from '../model/SuppressionSettingsModel';
import { CsvImportOptions } from './ContactsCotroller';

export default class SuppressionSettingsController extends AuthenticatedController {
  static createSettings(
    facebookPageId: number,
    entity: Partial<SuppressionSettingsModel>,
  ): Promise<SuppressionSettingsModel> {
    return super.post(
      `${APIRoutes.SUPPRESSION_SETTINGS}/${facebookPageId}`,
      entity,
    );
  }

  static getSettings(
    facebookPageId: number,
  ): Promise<SuppressionSettingsModel[]> {
    return super.get(`${APIRoutes.SUPPRESSION_SETTINGS}/${facebookPageId}`);
  }

  static getUploadedCsvFiles({
    facebookPageId,
    captureAction,
    page = 1,
    perPage = 100,
    kind,
  }: {
    facebookPageId: number;
    captureAction: CaptureActionEnum;
    page?: number;
    perPage?: number;
    kind?: SuppressionSettingsCSVModel['kind'];
  }): Promise<SuppressionSettingsCSVResponse> {
    return super.get(
      `${APIRoutes.SUPPRESSION_SETTINGS}/suppression_csvs/${facebookPageId}`,
      {
        page,
        perPage,
        kind,
        captureAction,
      },
    );
  }

  static updateSettings(
    facebookPageId: number,
    settingId: number,
    entity: Partial<SuppressionSettingsModel>,
  ): Promise<SuppressionSettingsModel> {
    return super.put(
      `${APIRoutes.SUPPRESSION_SETTINGS}/${facebookPageId}/${settingId}`,
      entity,
    );
  }

  static createCSV(
    facebookPageId: number,
    entity:
      | Omit<CsvImportOptions, 'facebookPageId'>
      | {
          googleAccountId: number;
          googleSpreadsheetId: number | string;
          googleSpreadsheetTitle: string;
          googleSheetId: number;
          googleSheetTitle: string;
          googleLookupColumn?: string;
        },
  ): Promise<SuppressionSettingsCSVModel> {
    return super.post(
      `${APIRoutes.SUPPRESSION_SETTINGS}/create_csv/${facebookPageId}`,
      entity,
    );
  }

  static updateCSV(
    csvId: number,
    entity: { uploaded: boolean },
  ): Promise<SuppressionSettingsCSVModel> {
    return super.put(
      `${APIRoutes.SUPPRESSION_SETTINGS}/update_csv/${csvId}`,
      entity,
    );
  }

  static deleteCSV(csvId: number): Promise<void> {
    return super.delete(
      `${APIRoutes.SUPPRESSION_SETTINGS}/delete_csv/${csvId}`,
    );
  }
}
